import { render, staticRenderFns } from "./WarnApproveModal.vue?vue&type=template&id=659b4756"
import script from "./WarnApproveModal.vue?vue&type=script&lang=js"
export * from "./WarnApproveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports